export type OuraLoggerFn = (message: string, options?: unknown) => void;

export interface ILogger {
  debug: OuraLoggerFn;
  info: OuraLoggerFn;
  warn: OuraLoggerFn;
  error: OuraLoggerFn;
}

export class ConsoleLogger implements ILogger {
  public debug(message: string, options?: unknown): void {
    console.debug(message, options || {});
  }

  public info(message: string, options?: unknown): void {
    console.info(message, options || {});
  }

  public warn(message: string, options?: unknown): void {
    console.warn(message, options || {});
  }

  public error(message: string, options?: unknown): void {
    console.error(message, options || {});
  }
}
